//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    BUY_PROPERTY,
    ELEVATOR_TYPE,
    LOCATION,
    calcNewHouse,
    checkSubmit,
    formatNumberInput
} from './utils'
export default {
    data () {
        return {
            type: '新房',
            unit_price: '',
            building_area: '',
            buy_propertys: BUY_PROPERTY,
            elevator_types: ELEVATOR_TYPE,
            locations: LOCATION,
            buy_property_index: 0,
            elevator_type_index: 0,
            location_index: 0,
        }
    },
    methods: {
        changeBuyProperty ({ target: { value } }) {
            this.buy_property_index = value
        },
        changeElevatorType ({ target: { value } }) {
            this.elevator_type_index = value
        },
        changeLocation ({ target: { value } }) {
            this.location_index = value
        },
        checkBuildingArea (e) {
            this.building_area = formatNumberInput(e)
        },
        checkUnitPrice (e) {
            this.unit_price = formatNumberInput(e)
        },
        calculate () {
            const params = {
                type: this.type,
                unit_price: this.unit_price,
                area: this.building_area,
                buy_property: this.buy_propertys[this.buy_property_index],
                elevator_type: this.elevator_types[this.elevator_type_index],
                location: this.locations[this.location_index]
            }
            const rules = {
                area: {
                    required: true,
                    text: '房屋面积'
                },
                unit_price: {
                    required: true,
                    text: '房屋单价'
                }
            }
            if (checkSubmit(params, rules)) {
                wx.navigateTo({
                    url: `/packageA/taxes_calculate/result?params=${JSON.stringify(calcNewHouse(params))}`
                })
            }
        }
    }
}
